import React, { memo } from "react";
// import QuestionStrategyVideoThumbnail from "assets/images/images_new/question-strategy-video.png"
// import Vipbg from "../../../../assets/images/vip-bg.svg"
// import VipCrown from "../../../../assets/images/vip-crown.svg"
import NewStrategyVideoThumbnail from "assets/images/images_new/strategyVideoNew.svg"

const QuestionStrategyVideo = memo(function QuestionStrategyVideo({
	subcategoryId, strategyVideo
}) {

	return (
		<div className="dash-col-2 dash-col-2-md-fit">
			<div className="strategy-video" onClick={() => strategyVideo(true)}>
				<div className="strategy-video-wrapper position-relative">
					<img
						src={NewStrategyVideoThumbnail}
					/>
					{/*<iframe
						className="str-video"
						src="https://www.youtube.com/embed/6WOv-BkFiYg?si=b3eODrl2vANY3-X3"
						title="YouTube video player"
						frameBorder="0"
						allowFullScreen
					></iframe>*/}
					{/* <div style={{bottom:"0", right:"-8px"}} className="position-absolute d-flex justify-content-center align-item-center">
                       <img style={{ width:"16px" , height:"16px" ,  }} src={Vipbg} alt="vip-bg" />
					   <img style={{ width:"11px" , height:"11px" , position:"absolute" , top:"3px" , left:"3px" }} src={VipCrown} alt="vip-crown" />
					</div> */}
				</div>
				{/* <span>Secret Video</span> */}
				<div className="d-grid new-strategy-video">
					<span className="m-0 vip">VIP MODE</span>
					<span className="m-0 strategy-active" >Strategy Active</span>
				</div>
			</div>
		</div>
	);
});
export default QuestionStrategyVideo;